import { combineReducers } from "@reduxjs/toolkit";
import purchaseOrderReducer from "./PurchaseOrderReducer";
import forecastOrderReducer from "./ForecastOrderReducer";
import goodsReceiveNotes from './GRNReducer'
import invoices from "./InvoiceReducer";
import rejectedQCReducer from "./RejectedQCReducer";
import rejectedQCForPOReducer from "./PORejectedReducer";
import rejectedQCHistoryReducer from "./RejectedQCHistoryReducer"
import generatedInvoices from './GeneratedInvoicesReducer'
import completedInvoices from "./CompletedInvoices";

 const reducers = combineReducers({
    purchaseOrders: purchaseOrderReducer,
    forecastOrder : forecastOrderReducer,
    goodsReceiveNotes : goodsReceiveNotes, 
    invoices : invoices,
    rejectedQC: rejectedQCReducer,
    rejectedQCForPO: rejectedQCForPOReducer,
    rejctedQCHistory : rejectedQCHistoryReducer,
    genratedInvoice : generatedInvoices,
    completedInvoices : completedInvoices,
})

export default reducers

